// extracted by mini-css-extract-plugin
module.exports = {"container":"index-container__1jagm","settings_btn":"index-settings_btn__1KbvE"};